<template>
  <layout-header />
  <layout-sidebar />

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <div class="mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-primary d-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#add_asset_category"
              v-can="'Asset.Create'"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Category
            </a>
          </div>
          <div class="ms-2 head-icons">
            <a href="javascript:void(0);" id="collapse-header" @click="toggleHeader">
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="card mb-3">
        <div class="card-body">
          <div class="row g-2 align-items-end">
            <div class="col-md-4">
              <label class="form-label">Search (name)</label>
              <input
                v-model="store.filters.search"
                type="text"
                class="form-control"
                placeholder="e.g. Laptops"
              />
            </div>
            <div class="col-md-3">
              <label class="form-label">Status</label>
              <select v-model="store.filters.status" class="form-select">
                <option value="">All</option>
                <option>Active</option>
                <option>Inactive</option>
              </select>
            </div>
            <div class="col-md-2 d-grid">
              <button class="btn btn-primary" @click="store.fetchAll({ page: 1 })">
                Filter
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="card">
        <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
          <h5>Asset Category List</h5>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <assets-categories-table
              :rows="store.items"
              :loading="store.loading"
              @edit="openEdit"
              @delete="confirmDelete"
              @bulk-delete="confirmBulkDelete"
            />
          </div>

          <div class="p-3 d-flex justify-content-between align-items-center">
            <div>
              Showing page {{ store.pagination.current_page }} of {{ totalPages }}
            </div>
            <div class="btn-group">
              <button
                class="btn btn-outline-secondary"
                :disabled="store.pagination.current_page <= 1"
                @click="store.fetchAll({ page: store.pagination.current_page - 1 })"
              >
                Prev
              </button>
              <button
                class="btn btn-outline-secondary"
                :disabled="store.pagination.current_page >= totalPages"
                @click="store.fetchAll({ page: store.pagination.current_page + 1 })"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>

  <assets-category-modal :edit-item="editItem" @saved="onSaved" />
</template>

<script setup>
import { computed, ref, nextTick, onMounted } from "vue";
import Modal from "bootstrap/js/dist/modal";
import { useAssetCategoryStore } from "@/stores/assetCategoryStore";
import AssetsCategoriesTable from "./assets-categories-table.vue";
import AssetsCategoryModal from "@/components/modal/assets-category-modal.vue";

const title = "Assets Category";
const text = "Administration";
const text1 = "Assets Category";

const store = useAssetCategoryStore();
const editItem = ref(null);
let editModal, deleteModal;

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function getOrCreateModal(el) {
  if (!el) return null;
  return Modal.getOrCreateInstance(el, { backdrop: true, keyboard: true });
}

const totalPages = computed(() => {
  const t = store.pagination.total || 0;
  const p = store.pagination.per_page || 25;
  return Math.max(1, Math.ceil(t / p));
});

function openEdit(row) {
  editItem.value = row;
  nextTick(() => {
    const el = document.getElementById("edit_asset_category");
    editModal = getOrCreateModal(el);
    editModal?.show();
  });
}

async function confirmDelete(row) {
  editItem.value = row;
  await nextTick();
  const el = document.getElementById("delete_modal");
  deleteModal = getOrCreateModal(el);
  deleteModal?.show();
}

async function confirmBulkDelete(ids) {
  if (!ids?.length) return;
  if (!confirm(`Delete ${ids.length} selected item(s)?`)) return;
  await store.bulkDelete(ids);
}

function onSaved() {
  editItem.value = null;
}

onMounted(() => {
  store.fetchAll();
  const editEl = document.getElementById("edit_asset_category");
  editEl?.addEventListener("hidden.bs.modal", () => {
    editItem.value = null;
  });
});
</script>


